'use client'
import { useEffect, useState } from 'react';
import clsx from "clsx";
import Headline from "@/components/typographie/Headlines/Headline";

interface Props {
    headline: string
}

interface HeadlineProps {
    text: string
    id: string
    tag: string
}

export default function Directory ({headline}:Props) {
    const [headlines, setHeadlines] = useState<HeadlineProps[]>([]);

    useEffect(() => {
        const main = document.querySelector('main');
        const headings = main?.querySelectorAll<HTMLElement>('h2:not(.directory-headline), h3, h4, h5, h6');
        if(!headings) return;
        headings.forEach((heading, index) => {
            heading.id = 'headline-' + index;
            heading.classList.add('scroll-mt-[100px]');
        })
        const headlineArray:HeadlineProps[] = Array.from(headings).map((heading) => ({
            text: heading.innerText,
            id: heading.id,
            tag: heading.tagName.toLowerCase(),
        }));
        setHeadlines(headlineArray);
    }, []);

    return (
        <div className="border p-m w-full">
            <Headline type="h2" className="directory-headline mb-s text-h3 font-sans">{headline}</Headline>
            <ul className="directory list-none m-[0]">
                {headlines.map((headline) => (
                    <li key={headline.id} className="py-xs">
                        <a href={`#${headline.id}`} className={clsx('headline-' + headline.tag, 'underline')}>{headline.text}</a>
                    </li>
                ))}
            </ul>
        </div>
    )
}